import {
  WORKFLOW_TYPE_OVERLAYS,
  WORKFLOW_TYPE_TARGET_SURFACE,
  WORKFLOW_TYPE_BASE_SURFACE,
  WORKFLOW_TYPE_PREPROCESSED_DATA,
  WORKFLOW_TYPE_SITE_CREATION,
  WORKFLOW_TYPE_GCP,
  WORKFLOW_TYPE_UPLOAD_DEM,
} from "./constants";

export function getWorkflowLogo(workflowType: string): string {
  switch (workflowType.toUpperCase()) {
    case WORKFLOW_TYPE_PREPROCESSED_DATA:
      return "./preprocessed-data-workflow.svg";
    case WORKFLOW_TYPE_UPLOAD_DEM:
      return "./upload-dem-workflow.svg";
    case WORKFLOW_TYPE_OVERLAYS:
      return "./overlays-workflow.svg";
    case WORKFLOW_TYPE_TARGET_SURFACE:
      return "./target-surface-workflow.svg";
    case WORKFLOW_TYPE_BASE_SURFACE:
      return "./base-surface-workflow.svg";
    case WORKFLOW_TYPE_GCP:
      return "./gcp-workflow.svg";
    case WORKFLOW_TYPE_SITE_CREATION:
      return "./onboarding-workflow.svg";
    default:
      return "";
  }
}

export function getWorkflowTitle(workflowType: string): string {
  switch (workflowType.toUpperCase()) {
    case WORKFLOW_TYPE_PREPROCESSED_DATA:
      return "Preprocessed Data";
    case WORKFLOW_TYPE_UPLOAD_DEM:
      return "Upload DEM";
    case WORKFLOW_TYPE_OVERLAYS:
      return "Overlays";
    case WORKFLOW_TYPE_TARGET_SURFACE:
      return "Design Grade";
    case WORKFLOW_TYPE_BASE_SURFACE:
      return "Original Ground Surface";
    case WORKFLOW_TYPE_GCP:
      return "Upload Flight Markers Measurements";
    default:
      return "";
  }
}

export function getWorkflowDescription(workflowType: string): string {
  switch (workflowType.toUpperCase()) {
    case WORKFLOW_TYPE_PREPROCESSED_DATA:
      return "Upload already processed Orthophoto and Digital Elevation Model (DEM) files.";
    case WORKFLOW_TYPE_UPLOAD_DEM:
      return "Upload DEM file to create a surface.";
    case WORKFLOW_TYPE_OVERLAYS:
      return "Upload 2D CAD (DWX, DXF, etc.) and PDF files to layer over scans.";
    case WORKFLOW_TYPE_TARGET_SURFACE:
      return "Upload 3D CAD file that indicates the top of the proposed grade.";
    case WORKFLOW_TYPE_BASE_SURFACE:
      return "Upload 3D topographic surface from surveyor or previous capture.";
    case WORKFLOW_TYPE_GCP:
      return "Once you have measured the coordinates of the flight markers, upload them in CSV, TXT, or GPX format.";
    default:
      return "";
  }
}

export function getWorkflowInitTitle(workflowType: string): string {
  switch (workflowType.toUpperCase()) {
    case WORKFLOW_TYPE_PREPROCESSED_DATA:
      return "Import New Orthophoto and DEM";
    case WORKFLOW_TYPE_UPLOAD_DEM:
      return "Import New DEM";
    case WORKFLOW_TYPE_OVERLAYS:
      return "Add new Overlay";
    case WORKFLOW_TYPE_TARGET_SURFACE:
      return "Add new Design Grade";
    case WORKFLOW_TYPE_BASE_SURFACE:
      return "Import Original Ground CAD file";
    case WORKFLOW_TYPE_GCP:
      return "Upload new CSV";
    default:
      return `Add new ${workflowType}`;
  }
}

export function getWorkflowDeletePermission(workflowType: string): string {
  return `BACKOFFICE_${workflowType.toUpperCase()}_WORKFLOW_DELETE`;
}

export function getWorkflowInputStepPermission(workflowType: string): string {
  return `BACKOFFICE_${workflowType.toUpperCase()}_WORKFLOW_INPUT_STEP`;
}

export function getWorkflowActionPermission(workflowType: string): string {
  return `BACKOFFICE_${workflowType.toUpperCase()}_WORKFLOW_ACTION`;
}

export function getWorkflowViewPermission(workflowType: string): string {
  return `BACKOFFICE_${workflowType.toUpperCase()}_WORKFLOW_VIEW`;
}

export function getWorkflowStartPermission(workflowType: string): string {
  return `BACKOFFICE_${workflowType.toUpperCase()}_WORKFLOW_START`;
}

export function getWorkflowRollbackPermission(workflowType: string): string {
  return "BACKOFFICE_WORKFLOW_ROLLBACK";
}
